import * as React from 'react'

interface IBoardNxProps {
  height?: number;
  width?: number;
  className?: string;
}

const BoardNx = ({ width = 360, height = 380, ...props }: IBoardNxProps) => (
  <svg width={width} height={height} viewBox="0 0 360 380" fill="none" {...props}>
    <g opacity={0.25} filter="url(#filter0_f_13_14293)">
      <rect y={10} width={360} height={360} rx={14} fill="black" />
    </g>
    <rect y={10} width={360} height={360} rx={14} fill="#0E36C5" />
    <rect y={351} width={323} height={1} transform="rotate(-90 0 351)" fill="url(#paint0_linear_13_14293)" fillOpacity={0.6} />
    <rect x={18} y={369} width={323} height={1} fill="url(#paint1_linear_13_14293)" fillOpacity={0.6} />
    <rect
      x={359}
      y={351}
      width={323}
      height={1}
      transform="rotate(-90 359 351)"
      fill="url(#paint2_linear_13_14293)"
      fillOpacity={0.6}
    />
    <rect x={18} y={10} width={323} height={1} fill="url(#paint3_linear_13_14293)" fillOpacity={0.6} />
    <rect x={6} y={16} width={348} height={348} rx={10} fill="#DDD8C8" stroke="#DDD8C8" strokeWidth={4} />
    <rect x={18} y={365} width={323} height={1} fill="url(#paint4_linear_13_14293)" />
    <rect x={4} y={351} width={323} height={1} transform="rotate(-90 4 351)" fill="url(#paint5_linear_13_14293)" />
    <rect x={355} y={351} width={323} height={1} transform="rotate(-90 355 351)" fill="url(#paint6_linear_13_14293)" />
    <rect x={18} y={14} width={323} height={1} fill="url(#paint7_linear_13_14293)" />
    <path
      d="M8.5 26C8.5 21.8579 11.8579 18.5 16 18.5H136C140.142 18.5 143.5 21.8579 143.5 26V146C143.5 150.142 140.142 153.5 136 153.5H16C11.8579 153.5 8.5 150.142 8.5 146V26Z"
      fill="#3E76E2"
      stroke="white"
    />
    <path
      d="M8.5 354C8.5 358.142 11.8579 361.5 16 361.5H136C140.142 361.5 143.5 358.142 143.5 354V234C143.5 229.858 140.142 226.5 136 226.5H16C11.8579 226.5 8.5 229.858 8.5 234V354Z"
      fill="#E0BB36"
      stroke="white"
    />
    {/* <circle cx={76} cy={284} r={28} fill="#F3F4F6" /> */}
    {/* <path
      opacity={0.6}
      d="M86 296H83.625V293.714C83.625 292.805 83.2497 291.933 82.5816 291.29C81.9135 290.647 81.0073 290.286 80.0625 290.286H72.9375C71.9927 290.286 71.0865 290.647 70.4184 291.29C69.7503 291.933 69.375 292.805 69.375 293.714V296H67V293.714C67 292.199 67.6256 290.745 68.7391 289.674C69.8526 288.602 71.3628 288 72.9375 288H80.0625C81.6372 288 83.1474 288.602 84.2609 289.674C85.3744 290.745 86 292.199 86 293.714V296ZM76.5 285.714C75.5643 285.714 74.6378 285.537 73.7734 285.192C72.9089 284.848 72.1235 284.343 71.4619 283.706C70.8002 283.069 70.2754 282.313 69.9174 281.481C69.5593 280.649 69.375 279.758 69.375 278.857C69.375 277.957 69.5593 277.065 69.9174 276.233C70.2754 275.401 70.8002 274.645 71.4619 274.008C72.1235 273.372 72.9089 272.867 73.7734 272.522C74.6378 272.177 75.5643 272 76.5 272C78.3897 272 80.2019 272.722 81.5381 274.008C82.8743 275.294 83.625 277.039 83.625 278.857C83.625 280.676 82.8743 282.42 81.5381 283.706C80.2019 284.992 78.3897 285.714 76.5 285.714ZM76.5 283.429C77.7598 283.429 78.968 282.947 79.8588 282.09C80.7496 281.232 81.25 280.07 81.25 278.857C81.25 277.645 80.7496 276.482 79.8588 275.625C78.968 274.767 77.7598 274.286 76.5 274.286C75.2402 274.286 74.032 274.767 73.1412 275.625C72.2504 276.482 71.75 277.645 71.75 278.857C71.75 280.07 72.2504 281.232 73.1412 282.09C74.032 282.947 75.2402 283.429 76.5 283.429Z"
      fill="#253974"
    /> */}
    <path d="M9 342H143V354C143 357.866 139.866 361 136 361H16C12.134 361 9 357.866 9 354V342Z" fill="#D5A321" />
    <path
      d="M351.5 26C351.5 21.8579 348.142 18.5 344 18.5H224C219.858 18.5 216.5 21.8579 216.5 26V146C216.5 150.142 219.858 153.5 224 153.5H344C348.142 153.5 351.5 150.142 351.5 146V26Z"
      fill="#C44242"
      stroke="white"
    />
    <path
      d="M351.5 354C351.5 358.142 348.142 361.5 344 361.5H224C219.858 361.5 216.5 358.142 216.5 354V234C216.5 229.858 219.858 226.5 224 226.5H344C348.142 226.5 351.5 229.858 351.5 234V354Z"
      fill="#2DCB70"
      stroke="white"
    />
    <path
      d="M150.2 226.4H162.8C164.888 226.4 166.6 228.085 166.6 230.1V242.4C166.6 244.415 164.888 246.1 162.8 246.1H150.2C148.112 246.1 146.4 244.415 146.4 242.4V230.1C146.4 228.079 148.018 226.4 150.2 226.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M150.2 272.4H162.8C164.888 272.4 166.6 274.085 166.6 276.1V288.4C166.6 290.415 164.888 292.1 162.8 292.1H150.2C148.112 292.1 146.4 290.415 146.4 288.4V276.1C146.4 274.079 148.018 272.4 150.2 272.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M150.2 318.5H162.8C164.835 318.5 166.5 320.142 166.5 322.1V334.4C166.5 336.358 164.835 338 162.8 338H150.2C148.165 338 146.5 336.358 146.5 334.4V322.1C146.5 320.134 148.073 318.5 150.2 318.5Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <path
      d="M156.5 322L158.41 325.871L162.682 326.491L159.591 329.504L160.321 333.759L156.5 331.75L152.679 333.759L153.409 329.504L150.318 326.491L154.59 325.871L156.5 322Z"
      fill="white"
    />
    <path
      d="M150.2 249.4H162.8C164.888 249.4 166.6 251.085 166.6 253.1V265.4C166.6 267.415 164.888 269.1 162.8 269.1H150.2C148.112 269.1 146.4 267.415 146.4 265.4V253.1C146.4 251.079 148.018 249.4 150.2 249.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M150.2 295.4H162.8C164.888 295.4 166.6 297.085 166.6 299.1V311.4C166.6 313.415 164.888 315.1 162.8 315.1H150.2C148.112 315.1 146.4 313.415 146.4 311.4V299.1C146.4 297.079 148.018 295.4 150.2 295.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M150.2 341.4H162.8C164.888 341.4 166.6 343.085 166.6 345.1V357.4C166.6 359.415 164.888 361.1 162.8 361.1H150.2C148.112 361.1 146.4 359.415 146.4 357.4V345.1C146.4 343.079 148.018 341.4 150.2 341.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M197.2 226.4H209.8C211.888 226.4 213.6 228.085 213.6 230.1V242.4C213.6 244.415 211.888 246.1 209.8 246.1H197.2C195.112 246.1 193.4 244.415 193.4 242.4V230.1C193.4 228.079 195.018 226.4 197.2 226.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M197.2 272.4H209.8C211.888 272.4 213.6 274.085 213.6 276.1V288.4C213.6 290.415 211.888 292.1 209.8 292.1H197.2C195.112 292.1 193.4 290.415 193.4 288.4V276.1C193.4 274.079 195.018 272.4 197.2 272.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M197.2 318.4H209.8C211.888 318.4 213.6 320.085 213.6 322.1V334.4C213.6 336.415 211.888 338.1 209.8 338.1H197.2C195.112 338.1 193.4 336.415 193.4 334.4V322.1C193.4 320.079 195.018 318.4 197.2 318.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M197.2 249.4H209.8C211.888 249.4 213.6 251.085 213.6 253.1V265.4C213.6 267.415 211.888 269.1 209.8 269.1H197.2C195.112 269.1 193.4 267.415 193.4 265.4V253.1C193.4 251.079 195.018 249.4 197.2 249.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M197.2 295.4H209.8C211.888 295.4 213.6 297.085 213.6 299.1V311.4C213.6 313.415 211.888 315.1 209.8 315.1H197.2C195.112 315.1 193.4 313.415 193.4 311.4V299.1C193.4 297.079 195.018 295.4 197.2 295.4Z"
      fill="#C3BEAB"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M203.5 299L205.41 302.871L209.682 303.491L206.591 306.504L207.321 310.759L203.5 308.75L199.679 310.759L200.409 306.504L197.318 303.491L201.59 302.871L203.5 299Z"
      fill="white"
    />
    <path
      d="M197.2 341.4H209.8C211.888 341.4 213.6 343.085 213.6 345.1V357.4C213.6 359.415 211.888 361.1 209.8 361.1H197.2C195.112 361.1 193.4 359.415 193.4 357.4V345.1C193.4 343.079 195.018 341.4 197.2 341.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M173.7 226.5H186.3C188.335 226.5 190 228.142 190 230.1V242.4C190 244.358 188.335 246 186.3 246H173.7C171.665 246 170 244.358 170 242.4V230.1C170 228.134 171.573 226.5 173.7 226.5Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <path
      d="M173.7 272.5H186.3C188.335 272.5 190 274.142 190 276.1V288.4C190 290.358 188.335 292 186.3 292H173.7C171.665 292 170 290.358 170 288.4V276.1C170 274.134 171.573 272.5 173.7 272.5Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <path
      d="M173.7 318.5H186.3C188.335 318.5 190 320.142 190 322.1V334.4C190 336.358 188.335 338 186.3 338H173.7C171.665 338 170 336.358 170 334.4V322.1C170 320.134 171.573 318.5 173.7 318.5Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <path
      d="M173.7 249.5H186.3C188.335 249.5 190 251.142 190 253.1V265.4C190 267.358 188.335 269 186.3 269H173.7C171.665 269 170 267.358 170 265.4V253.1C170 251.134 171.573 249.5 173.7 249.5Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <path
      d="M173.7 295.5H186.3C188.335 295.5 190 297.142 190 299.1V311.4C190 313.358 188.335 315 186.3 315H173.7C171.665 315 170 313.358 170 311.4V299.1C170 297.134 171.573 295.5 173.7 295.5Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <path
      d="M173.7 341.4H186.3C188.388 341.4 190.1 343.085 190.1 345.1V357.4C190.1 359.415 188.388 361.1 186.3 361.1H173.7C171.612 361.1 169.9 359.415 169.9 357.4V345.1C169.9 343.079 171.518 341.4 173.7 341.4Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M180.174 346.821L180 346.652L179.826 346.821L173.826 352.639L173.641 352.818L173.826 352.998L176.076 355.179L176.25 355.348L176.424 355.179L180 351.712L183.576 355.179L183.75 355.348L183.924 355.179L186.174 352.998L186.359 352.818L186.174 352.639L180.174 346.821Z"
      fill="#FDBC39"
      stroke="#D79C29"
      strokeWidth={0.5}
    />
    <path
      d="M209.8 154.1L197.2 154.1C195.112 154.1 193.4 152.415 193.4 150.4L193.4 138.1C193.4 136.085 195.112 134.4 197.2 134.4L209.8 134.4C211.888 134.4 213.6 136.085 213.6 138.1L213.6 150.4C213.6 152.421 211.982 154.1 209.8 154.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M209.8 108.1L197.2 108.1C195.112 108.1 193.4 106.415 193.4 104.4L193.4 92.1C193.4 90.0847 195.112 88.4 197.2 88.4L209.8 88.4C211.888 88.4 213.6 90.0847 213.6 92.1L213.6 104.4C213.6 106.421 211.982 108.1 209.8 108.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M209.8 62.1L197.2 62.1C195.112 62.1 193.4 60.4153 193.4 58.4L193.4 46.1C193.4 44.0847 195.112 42.4 197.2 42.4L209.8 42.4C211.888 42.4 213.6 44.0847 213.6 46.1L213.6 58.4C213.6 60.4215 211.982 62.1 209.8 62.1Z"
      fill="#BA2B2B"
      stroke="#9E2727"
      strokeWidth={0.8}
    />
    <path
      d="M203.5 46L205.41 49.8707L209.682 50.4914L206.591 53.5043L207.321 57.7586L203.5 55.75L199.679 57.7586L200.409 53.5043L197.318 50.4914L201.59 49.8707L203.5 46Z"
      fill="white"
    />
    <path
      d="M209.8 131.1L197.2 131.1C195.112 131.1 193.4 129.415 193.4 127.4L193.4 115.1C193.4 113.085 195.112 111.4 197.2 111.4L209.8 111.4C211.888 111.4 213.6 113.085 213.6 115.1L213.6 127.4C213.6 129.421 211.982 131.1 209.8 131.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M209.8 85.1L197.2 85.1C195.112 85.1 193.4 83.4153 193.4 81.4L193.4 69.1C193.4 67.0847 195.112 65.4 197.2 65.4L209.8 65.4C211.888 65.4 213.6 67.0847 213.6 69.1L213.6 81.4C213.6 83.4215 211.982 85.1 209.8 85.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M209.8 39.1L197.2 39.1C195.112 39.1 193.4 37.4153 193.4 35.4L193.4 23.1C193.4 21.0847 195.112 19.4 197.2 19.4L209.8 19.4C211.888 19.4 213.6 21.0847 213.6 23.1L213.6 35.4C213.6 37.4215 211.982 39.1 209.8 39.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M162.8 154.1L150.2 154.1C148.112 154.1 146.4 152.415 146.4 150.4L146.4 138.1C146.4 136.085 148.112 134.4 150.2 134.4L162.8 134.4C164.888 134.4 166.6 136.085 166.6 138.1L166.6 150.4C166.6 152.421 164.982 154.1 162.8 154.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M162.8 108.1L150.2 108.1C148.112 108.1 146.4 106.415 146.4 104.4L146.4 92.1C146.4 90.0847 148.112 88.4 150.2 88.4L162.8 88.4C164.888 88.4 166.6 90.0847 166.6 92.1L166.6 104.4C166.6 106.421 164.982 108.1 162.8 108.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M162.8 62.1L150.2 62.1C148.112 62.1 146.4 60.4153 146.4 58.4L146.4 46.1C146.4 44.0847 148.112 42.4 150.2 42.4L162.8 42.4C164.888 42.4 166.6 44.0847 166.6 46.1L166.6 58.4C166.6 60.4215 164.982 62.1 162.8 62.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M162.8 131.1L150.2 131.1C148.112 131.1 146.4 129.415 146.4 127.4L146.4 115.1C146.4 113.085 148.112 111.4 150.2 111.4L162.8 111.4C164.888 111.4 166.6 113.085 166.6 115.1L166.6 127.4C166.6 129.421 164.982 131.1 162.8 131.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M162.8 85.1L150.2 85.1C148.112 85.1 146.4 83.4153 146.4 81.4L146.4 69.1C146.4 67.0847 148.112 65.4 150.2 65.4L162.8 65.4C164.888 65.4 166.6 67.0847 166.6 69.1L166.6 81.4C166.6 83.4215 164.982 85.1 162.8 85.1Z"
      fill="#C3BEAB"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M156.5 69L158.41 72.8707L162.682 73.4914L159.591 76.5043L160.321 80.7586L156.5 78.75L152.679 80.7586L153.409 76.5043L150.318 73.4914L154.59 72.8707L156.5 69Z"
      fill="white"
    />
    <path
      d="M162.8 39.1L150.2 39.1C148.112 39.1 146.4 37.4153 146.4 35.4L146.4 23.1C146.4 21.0847 148.112 19.4 150.2 19.4L162.8 19.4C164.888 19.4 166.6 21.0847 166.6 23.1L166.6 35.4C166.6 37.4215 164.982 39.1 162.8 39.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M186.3 154.1L173.7 154.1C171.612 154.1 169.9 152.415 169.9 150.4L169.9 138.1C169.9 136.085 171.612 134.4 173.7 134.4L186.3 134.4C188.388 134.4 190.1 136.085 190.1 138.1L190.1 150.4C190.1 152.421 188.482 154.1 186.3 154.1Z"
      fill="#BA2B2B"
      stroke="#9E2727"
      strokeWidth={0.8}
    />
    <path
      d="M186.3 108.1L173.7 108.1C171.612 108.1 169.9 106.415 169.9 104.4L169.9 92.1C169.9 90.0847 171.612 88.4 173.7 88.4L186.3 88.4C188.388 88.4 190.1 90.0847 190.1 92.1L190.1 104.4C190.1 106.421 188.482 108.1 186.3 108.1Z"
      fill="#BA2B2B"
      stroke="#9E2727"
      strokeWidth={0.8}
    />
    <path
      d="M186.3 62.1L173.7 62.1C171.612 62.1 169.9 60.4153 169.9 58.4L169.9 46.1C169.9 44.0847 171.612 42.4 173.7 42.4L186.3 42.4C188.388 42.4 190.1 44.0847 190.1 46.1L190.1 58.4C190.1 60.4215 188.482 62.1 186.3 62.1Z"
      fill="#BA2B2B"
      stroke="#9E2727"
      strokeWidth={0.8}
    />
    <path
      d="M186.3 131.1L173.7 131.1C171.612 131.1 169.9 129.415 169.9 127.4L169.9 115.1C169.9 113.085 171.612 111.4 173.7 111.4L186.3 111.4C188.388 111.4 190.1 113.085 190.1 115.1L190.1 127.4C190.1 129.421 188.482 131.1 186.3 131.1Z"
      fill="#BA2B2B"
      stroke="#9E2727"
      strokeWidth={0.8}
    />
    <path
      d="M186.3 85.1L173.7 85.1C171.612 85.1 169.9 83.4153 169.9 81.4L169.9 69.1C169.9 67.0847 171.612 65.4 173.7 65.4L186.3 65.4C188.388 65.4 190.1 67.0847 190.1 69.1L190.1 81.4C190.1 83.4215 188.482 85.1 186.3 85.1Z"
      fill="#BA2B2B"
      stroke="#9E2727"
      strokeWidth={0.8}
    />
    <path
      d="M186.3 39.1L173.7 39.1C171.612 39.1 169.9 37.4153 169.9 35.4L169.9 23.1C169.9 21.0847 171.612 19.4 173.7 19.4L186.3 19.4C188.388 19.4 190.1 21.0847 190.1 23.1L190.1 35.4C190.1 37.4215 188.482 39.1 186.3 39.1Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M179.826 33.1795L180 33.3482L180.174 33.1795L186.174 27.3613L186.359 27.1818L186.174 27.0023L183.924 24.8205L183.75 24.6518L183.576 24.8205L180 28.2881L176.424 24.8205L176.25 24.6518L176.076 24.8205L173.826 27.0023L173.641 27.1818L173.826 27.3613L179.826 33.1795Z"
      fill="#CA2B3E"
      stroke="#A52D43"
      strokeWidth={0.5}
    />
    <path
      d="M29.1 160.2L29.1 172.8C29.1 174.888 27.4153 176.6 25.4 176.6L13.1 176.6C11.0847 176.6 9.4 174.888 9.4 172.8L9.4 160.2C9.4 158.112 11.0847 156.4 13.1 156.4L25.4 156.4C27.4215 156.4 29.1 158.018 29.1 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M29.1 207.2L29.1 219.8C29.1 221.888 27.4153 223.6 25.4 223.6L13.1 223.6C11.0847 223.6 9.4 221.888 9.4 219.8L9.4 207.2C9.4 205.112 11.0847 203.4 13.1 203.4L25.4 203.4C27.4215 203.4 29.1 205.018 29.1 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M29.1 183.7L29.1 196.3C29.1 198.388 27.4153 200.1 25.4 200.1L13.1 200.1C11.0847 200.1 9.4 198.388 9.4 196.3L9.4 183.7C9.4 181.612 11.0847 179.9 13.1 179.9L25.4 179.9C27.4215 179.9 29.1 181.518 29.1 183.7Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M23.1796 190.174L23.3484 190L23.1796 189.826L17.3614 183.826L17.182 183.641L17.0025 183.826L14.8207 186.076L14.6519 186.25L14.8207 186.424L18.2883 190L14.8207 193.576L14.6519 193.75L14.8207 193.924L17.0025 196.174L17.182 196.359L17.3614 196.174L23.1796 190.174Z"
      fill="#076FEF"
      stroke="#3655C1"
      strokeWidth={0.5}
    />
    <path
      d="M52.1 160.2L52.1 172.8C52.1 174.888 50.4153 176.6 48.4 176.6L36.1 176.6C34.0847 176.6 32.4 174.888 32.4 172.8L32.4 160.2C32.4 158.112 34.0847 156.4 36.1 156.4L48.4 156.4C50.4215 156.4 52.1 158.018 52.1 160.2Z"
      fill="#326CDD"
      stroke="#3655C1"
      strokeWidth={0.8}
    />
    <path
      d="M42.5 160L44.4103 163.871L48.6819 164.491L45.5909 167.504L46.3206 171.759L42.5 169.75L38.6794 171.759L39.4091 167.504L36.3181 164.491L40.5897 163.871L42.5 160Z"
      fill="white"
    />
    <path
      d="M52.1 207.2L52.1 219.8C52.1 221.888 50.4153 223.6 48.4 223.6L36.1 223.6C34.0847 223.6 32.4 221.888 32.4 219.8L32.4 207.2C32.4 205.112 34.0847 203.4 36.1 203.4L48.4 203.4C50.4215 203.4 52.1 205.018 52.1 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M52.1 183.7L52.1 196.3C52.1 198.388 50.4153 200.1 48.4 200.1L36.1 200.1C34.0847 200.1 32.4 198.388 32.4 196.3L32.4 183.7C32.4 181.612 34.0847 179.9 36.1 179.9L48.4 179.9C50.4215 179.9 52.1 181.518 52.1 183.7Z"
      fill="#326CDD"
      stroke="#3655C1"
      strokeWidth={0.8}
    />
    <path
      d="M75.1 160.2L75.1 172.8C75.1 174.888 73.4153 176.6 71.4 176.6L59.1 176.6C57.0847 176.6 55.4 174.888 55.4 172.8L55.4 160.2C55.4 158.112 57.0847 156.4 59.1 156.4L71.4 156.4C73.4215 156.4 75.1 158.018 75.1 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M75.1 207.2L75.1 219.8C75.1 221.888 73.4153 223.6 71.4 223.6L59.1 223.6C57.0847 223.6 55.4 221.888 55.4 219.8L55.4 207.2C55.4 205.112 57.0847 203.4 59.1 203.4L71.4 203.4C73.4215 203.4 75.1 205.018 75.1 207.2Z"
      fill="#C3BEAB"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M65.5 207L67.4103 210.871L71.6819 211.491L68.5909 214.504L69.3206 218.759L65.5 216.75L61.6794 218.759L62.4091 214.504L59.3181 211.491L63.5897 210.871L65.5 207Z"
      fill="white"
    />
    <path
      d="M75.1 183.7L75.1 196.3C75.1 198.388 73.4153 200.1 71.4 200.1L59.1 200.1C57.0847 200.1 55.4 198.388 55.4 196.3L55.4 183.7C55.4 181.612 57.0847 179.9 59.1 179.9L71.4 179.9C73.4215 179.9 75.1 181.518 75.1 183.7Z"
      fill="#326CDD"
      stroke="#3655C1"
      strokeWidth={0.8}
    />
    <path
      d="M98.1 160.2L98.1 172.8C98.1 174.888 96.4153 176.6 94.4 176.6L82.1 176.6C80.0847 176.6 78.4 174.888 78.4 172.8L78.4 160.2C78.4 158.112 80.0847 156.4 82.1 156.4L94.4 156.4C96.4215 156.4 98.1 158.018 98.1 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M98.1 207.2L98.1 219.8C98.1 221.888 96.4153 223.6 94.4 223.6L82.1 223.6C80.0847 223.6 78.4 221.888 78.4 219.8L78.4 207.2C78.4 205.112 80.0847 203.4 82.1 203.4L94.4 203.4C96.4215 203.4 98.1 205.018 98.1 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M98.1 183.7L98.1 196.3C98.1 198.388 96.4153 200.1 94.4 200.1L82.1 200.1C80.0847 200.1 78.4 198.388 78.4 196.3L78.4 183.7C78.4 181.612 80.0847 179.9 82.1 179.9L94.4 179.9C96.4215 179.9 98.1 181.518 98.1 183.7Z"
      fill="#326CDD"
      stroke="#3655C1"
      strokeWidth={0.8}
    />
    <path
      d="M121.1 160.2L121.1 172.8C121.1 174.888 119.415 176.6 117.4 176.6L105.1 176.6C103.085 176.6 101.4 174.888 101.4 172.8L101.4 160.2C101.4 158.112 103.085 156.4 105.1 156.4L117.4 156.4C119.421 156.4 121.1 158.018 121.1 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M121.1 207.2L121.1 219.8C121.1 221.888 119.415 223.6 117.4 223.6L105.1 223.6C103.085 223.6 101.4 221.888 101.4 219.8L101.4 207.2C101.4 205.112 103.085 203.4 105.1 203.4L117.4 203.4C119.421 203.4 121.1 205.018 121.1 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M121.1 183.7L121.1 196.3C121.1 198.388 119.415 200.1 117.4 200.1L105.1 200.1C103.085 200.1 101.4 198.388 101.4 196.3L101.4 183.7C101.4 181.612 103.085 179.9 105.1 179.9L117.4 179.9C119.421 179.9 121.1 181.518 121.1 183.7Z"
      fill="#326CDD"
      stroke="#3655C1"
      strokeWidth={0.8}
    />
    <path
      d="M144.1 160.2L144.1 172.8C144.1 174.888 142.415 176.6 140.4 176.6L128.1 176.6C126.085 176.6 124.4 174.888 124.4 172.8L124.4 160.2C124.4 158.112 126.085 156.4 128.1 156.4L140.4 156.4C142.421 156.4 144.1 158.018 144.1 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M144.1 207.2L144.1 219.8C144.1 221.888 142.415 223.6 140.4 223.6L128.1 223.6C126.085 223.6 124.4 221.888 124.4 219.8L124.4 207.2C124.4 205.112 126.085 203.4 128.1 203.4L140.4 203.4C142.421 203.4 144.1 205.018 144.1 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M144.1 183.7L144.1 196.3C144.1 198.388 142.415 200.1 140.4 200.1L128.1 200.1C126.085 200.1 124.4 198.388 124.4 196.3L124.4 183.7C124.4 181.612 126.085 179.9 128.1 179.9L140.4 179.9C142.421 179.9 144.1 181.518 144.1 183.7Z"
      fill="#326CDD"
      stroke="#3655C1"
      strokeWidth={0.8}
    />
    <path
      d="M330.9 160.2L330.9 172.8C330.9 174.888 332.585 176.6 334.6 176.6L346.9 176.6C348.915 176.6 350.6 174.888 350.6 172.8L350.6 160.2C350.6 158.112 348.915 156.4 346.9 156.4L334.6 156.4C332.579 156.4 330.9 158.018 330.9 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M330.9 207.2L330.9 219.8C330.9 221.888 332.585 223.6 334.6 223.6L346.9 223.6C348.915 223.6 350.6 221.888 350.6 219.8L350.6 207.2C350.6 205.112 348.915 203.4 346.9 203.4L334.6 203.4C332.579 203.4 330.9 205.018 330.9 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M330.7 183.7L330.7 196.3C330.7 198.494 332.47 200.3 334.6 200.3L346.9 200.3C349.03 200.3 350.8 198.494 350.8 196.3L350.8 183.7C350.8 181.506 349.03 179.7 346.9 179.7L334.6 179.7C332.467 179.7 330.7 181.409 330.7 183.7Z"
      fill="#F5F9FC"
      stroke="#8A8A8A"
      strokeWidth={0.4}
    />
    <path
      d="M336.821 189.826L336.652 190L336.821 190.174L342.639 196.174L342.818 196.359L342.998 196.174L345.179 193.924L345.348 193.75L345.179 193.576L341.712 190L345.179 186.424L345.348 186.25L345.179 186.076L342.998 183.826L342.818 183.641L342.639 183.826L336.821 189.826Z"
      fill="#39C429"
      stroke="#2A9B54"
      strokeWidth={0.5}
    />
    <path
      d="M307.9 160.2L307.9 172.8C307.9 174.888 309.585 176.6 311.6 176.6L323.9 176.6C325.915 176.6 327.6 174.888 327.6 172.8L327.6 160.2C327.6 158.112 325.915 156.4 323.9 156.4L311.6 156.4C309.579 156.4 307.9 158.018 307.9 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M307.9 207.2L307.9 219.8C307.9 221.888 309.585 223.6 311.6 223.6L323.9 223.6C325.915 223.6 327.6 221.888 327.6 219.8L327.6 207.2C327.6 205.112 325.915 203.4 323.9 203.4L311.6 203.4C309.579 203.4 307.9 205.018 307.9 207.2Z"
      fill="#28C269"
      stroke="#2A9B54"
      strokeWidth={0.8}
    />
    <path
      d="M317.5 207L319.41 210.871L323.682 211.491L320.591 214.504L321.321 218.759L317.5 216.75L313.679 218.759L314.409 214.504L311.318 211.491L315.59 210.871L317.5 207Z"
      fill="white"
    />
    <path
      d="M307.9 183.7L307.9 196.3C307.9 198.388 309.585 200.1 311.6 200.1L323.9 200.1C325.915 200.1 327.6 198.388 327.6 196.3L327.6 183.7C327.6 181.612 325.915 179.9 323.9 179.9L311.6 179.9C309.579 179.9 307.9 181.518 307.9 183.7Z"
      fill="#28C269"
      stroke="#2A9B54"
      strokeWidth={0.8}
    />
    <path
      d="M284.9 160.2L284.9 172.8C284.9 174.888 286.585 176.6 288.6 176.6L300.9 176.6C302.915 176.6 304.6 174.888 304.6 172.8L304.6 160.2C304.6 158.112 302.915 156.4 300.9 156.4L288.6 156.4C286.579 156.4 284.9 158.018 284.9 160.2Z"
      fill="#C3BEAB"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M294.5 160L296.41 163.871L300.682 164.491L297.591 167.504L298.321 171.759L294.5 169.75L290.679 171.759L291.409 167.504L288.318 164.491L292.59 163.871L294.5 160Z"
      fill="white"
    />
    <path
      d="M284.9 207.2L284.9 219.8C284.9 221.888 286.585 223.6 288.6 223.6L300.9 223.6C302.915 223.6 304.6 221.888 304.6 219.8L304.6 207.2C304.6 205.112 302.915 203.4 300.9 203.4L288.6 203.4C286.579 203.4 284.9 205.018 284.9 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M284.9 183.7L284.9 196.3C284.9 198.388 286.585 200.1 288.6 200.1L300.9 200.1C302.915 200.1 304.6 198.388 304.6 196.3L304.6 183.7C304.6 181.612 302.915 179.9 300.9 179.9L288.6 179.9C286.579 179.9 284.9 181.518 284.9 183.7Z"
      fill="#28C269"
      stroke="#2A9B54"
      strokeWidth={0.8}
    />
    <path
      d="M261.9 160.2L261.9 172.8C261.9 174.888 263.585 176.6 265.6 176.6L277.9 176.6C279.915 176.6 281.6 174.888 281.6 172.8L281.6 160.2C281.6 158.112 279.915 156.4 277.9 156.4L265.6 156.4C263.579 156.4 261.9 158.018 261.9 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M261.9 207.2L261.9 219.8C261.9 221.888 263.585 223.6 265.6 223.6L277.9 223.6C279.915 223.6 281.6 221.888 281.6 219.8L281.6 207.2C281.6 205.112 279.915 203.4 277.9 203.4L265.6 203.4C263.579 203.4 261.9 205.018 261.9 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M261.9 183.7L261.9 196.3C261.9 198.388 263.585 200.1 265.6 200.1L277.9 200.1C279.915 200.1 281.6 198.388 281.6 196.3L281.6 183.7C281.6 181.612 279.915 179.9 277.9 179.9L265.6 179.9C263.579 179.9 261.9 181.518 261.9 183.7Z"
      fill="#28C269"
      stroke="#2A9B54"
      strokeWidth={0.8}
    />
    <path
      d="M238.9 160.2L238.9 172.8C238.9 174.888 240.585 176.6 242.6 176.6L254.9 176.6C256.915 176.6 258.6 174.888 258.6 172.8L258.6 160.2C258.6 158.112 256.915 156.4 254.9 156.4L242.6 156.4C240.579 156.4 238.9 158.018 238.9 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M238.9 207.2L238.9 219.8C238.9 221.888 240.585 223.6 242.6 223.6L254.9 223.6C256.915 223.6 258.6 221.888 258.6 219.8L258.6 207.2C258.6 205.112 256.915 203.4 254.9 203.4L242.6 203.4C240.579 203.4 238.9 205.018 238.9 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M238.9 183.7L238.9 196.3C238.9 198.388 240.585 200.1 242.6 200.1L254.9 200.1C256.915 200.1 258.6 198.388 258.6 196.3L258.6 183.7C258.6 181.612 256.915 179.9 254.9 179.9L242.6 179.9C240.579 179.9 238.9 181.518 238.9 183.7Z"
      fill="#28C269"
      stroke="#2A9B54"
      strokeWidth={0.8}
    />
    <path
      d="M215.9 160.2L215.9 172.8C215.9 174.888 217.585 176.6 219.6 176.6L231.9 176.6C233.915 176.6 235.6 174.888 235.6 172.8L235.6 160.2C235.6 158.112 233.915 156.4 231.9 156.4L219.6 156.4C217.579 156.4 215.9 158.018 215.9 160.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M215.9 207.2L215.9 219.8C215.9 221.888 217.585 223.6 219.6 223.6L231.9 223.6C233.915 223.6 235.6 221.888 235.6 219.8L235.6 207.2C235.6 205.112 233.915 203.4 231.9 203.4L219.6 203.4C217.579 203.4 215.9 205.018 215.9 207.2Z"
      fill="white"
      stroke="#AAA799"
      strokeWidth={0.8}
    />
    <path
      d="M215.9 183.7L215.9 196.3C215.9 198.388 217.585 200.1 219.6 200.1L231.9 200.1C233.915 200.1 235.6 198.388 235.6 196.3L235.6 183.7C235.6 181.612 233.915 179.9 231.9 179.9L219.6 179.9C217.579 179.9 215.9 181.518 215.9 183.7Z"
      fill="#28C269"
      stroke="#2A9B54"
      strokeWidth={0.8}
    />
    <path
      d="M180.354 188.939C180.158 189.135 179.842 189.135 179.646 188.939L150.061 159.354C149.746 159.039 149.969 158.5 150.414 158.5L209.586 158.5C210.031 158.5 210.254 159.039 209.939 159.354L180.354 188.939Z"
      fill="#BA2B2B"
      stroke="#BA3A3A"
    />
    <path
      d="M177.925 190.144C178.124 190.34 178.124 190.66 177.925 190.856L148.351 219.969C148.035 220.28 147.5 220.056 147.5 219.612L147.5 161.388C147.5 160.944 148.035 160.72 148.351 161.031L177.925 190.144Z"
      fill="#326CDD"
      stroke="#3655C1"
    />
    <path
      d="M182.075 190.144C181.876 190.34 181.876 190.66 182.075 190.856L211.649 219.969C211.965 220.28 212.5 220.056 212.5 219.612L212.5 161.388C212.5 160.944 211.965 160.72 211.649 161.031L182.075 190.144Z"
      fill="#28C269"
      stroke="#2A9B54"
    />
    <path
      d="M179.646 192.061C179.842 191.865 180.158 191.865 180.354 192.061L209.939 221.646C210.254 221.961 210.031 222.5 209.586 222.5H150.414C149.969 222.5 149.746 221.961 150.061 221.646L179.646 192.061Z"
      fill="#EABD1D"
      stroke="#D79C29"
    />
    <mask id="path-109-outside-1_13_14293" maskUnits="userSpaceOnUse" x={170} y={182} width={20} height={16} fill="black">
      <rect fill="white" x={170} y={182} width={20} height={16} />
      <path d="M179.396 186.45L173.875 190.959V195.825C173.875 195.951 173.926 196.072 174.016 196.161C174.105 196.25 174.227 196.3 174.354 196.3L177.71 196.291C177.837 196.291 177.958 196.24 178.047 196.151C178.137 196.062 178.187 195.942 178.187 195.816V192.975C178.187 192.849 178.237 192.728 178.327 192.639C178.417 192.55 178.539 192.499 178.666 192.499H180.582C180.71 192.499 180.831 192.55 180.921 192.639C181.011 192.728 181.062 192.849 181.062 192.975V195.814C181.061 195.877 181.074 195.939 181.098 195.996C181.122 196.054 181.157 196.107 181.201 196.151C181.246 196.195 181.299 196.231 181.357 196.254C181.415 196.278 181.478 196.291 181.541 196.291L184.895 196.3C185.022 196.3 185.144 196.25 185.234 196.161C185.324 196.072 185.374 195.951 185.374 195.825V190.955L179.854 186.45C179.79 186.398 179.709 186.37 179.625 186.37C179.542 186.37 179.461 186.398 179.396 186.45ZM188.117 189.515L185.614 187.468V184.306C185.614 184.211 185.576 184.121 185.509 184.054C185.441 183.987 185.35 183.95 185.255 183.95H183.578C183.482 183.95 183.391 183.987 183.324 184.054C183.256 184.121 183.218 184.211 183.218 184.306V185.512L180.537 183.325C180.28 183.115 179.957 183 179.624 183C179.291 183 178.968 183.115 178.711 183.325L171.13 189.515C171.094 189.544 171.064 189.581 171.042 189.622C171.02 189.664 171.006 189.709 171.002 189.756C170.997 189.802 171.002 189.849 171.016 189.894C171.03 189.939 171.052 189.98 171.082 190.016L171.846 190.937C171.876 190.973 171.913 191.003 171.955 191.025C171.996 191.047 172.042 191.061 172.089 191.065C172.136 191.07 172.184 191.065 172.229 191.051C172.274 191.037 172.316 191.015 172.352 190.985L179.396 185.233C179.461 185.181 179.542 185.153 179.625 185.153C179.709 185.153 179.79 185.181 179.854 185.233L186.899 190.985C186.935 191.015 186.977 191.037 187.022 191.051C187.067 191.065 187.115 191.07 187.162 191.065C187.209 191.061 187.254 191.047 187.296 191.026C187.338 191.004 187.375 190.974 187.405 190.938L188.168 190.017C188.198 189.981 188.221 189.939 188.235 189.894C188.248 189.849 188.253 189.802 188.248 189.755C188.243 189.709 188.229 189.663 188.207 189.622C188.185 189.581 188.154 189.544 188.117 189.515Z" />
    </mask>
    <path
      d="M179.396 186.45L173.875 190.959V195.825C173.875 195.951 173.926 196.072 174.016 196.161C174.105 196.25 174.227 196.3 174.354 196.3L177.71 196.291C177.837 196.291 177.958 196.24 178.047 196.151C178.137 196.062 178.187 195.942 178.187 195.816V192.975C178.187 192.849 178.237 192.728 178.327 192.639C178.417 192.55 178.539 192.499 178.666 192.499H180.582C180.71 192.499 180.831 192.55 180.921 192.639C181.011 192.728 181.062 192.849 181.062 192.975V195.814C181.061 195.877 181.074 195.939 181.098 195.996C181.122 196.054 181.157 196.107 181.201 196.151C181.246 196.195 181.299 196.231 181.357 196.254C181.415 196.278 181.478 196.291 181.541 196.291L184.895 196.3C185.022 196.3 185.144 196.25 185.234 196.161C185.324 196.072 185.374 195.951 185.374 195.825V190.955L179.854 186.45C179.79 186.398 179.709 186.37 179.625 186.37C179.542 186.37 179.461 186.398 179.396 186.45ZM188.117 189.515L185.614 187.468V184.306C185.614 184.211 185.576 184.121 185.509 184.054C185.441 183.987 185.35 183.95 185.255 183.95H183.578C183.482 183.95 183.391 183.987 183.324 184.054C183.256 184.121 183.218 184.211 183.218 184.306V185.512L180.537 183.325C180.28 183.115 179.957 183 179.624 183C179.291 183 178.968 183.115 178.711 183.325L171.13 189.515C171.094 189.544 171.064 189.581 171.042 189.622C171.02 189.664 171.006 189.709 171.002 189.756C170.997 189.802 171.002 189.849 171.016 189.894C171.03 189.939 171.052 189.98 171.082 190.016L171.846 190.937C171.876 190.973 171.913 191.003 171.955 191.025C171.996 191.047 172.042 191.061 172.089 191.065C172.136 191.07 172.184 191.065 172.229 191.051C172.274 191.037 172.316 191.015 172.352 190.985L179.396 185.233C179.461 185.181 179.542 185.153 179.625 185.153C179.709 185.153 179.79 185.181 179.854 185.233L186.899 190.985C186.935 191.015 186.977 191.037 187.022 191.051C187.067 191.065 187.115 191.07 187.162 191.065C187.209 191.061 187.254 191.047 187.296 191.026C187.338 191.004 187.375 190.974 187.405 190.938L188.168 190.017C188.198 189.981 188.221 189.939 188.235 189.894C188.248 189.849 188.253 189.802 188.248 189.755C188.243 189.709 188.229 189.663 188.207 189.622C188.185 189.581 188.154 189.544 188.117 189.515Z"
      fill="white"
    />
    <path
      d="M179.396 186.45L178.772 185.669L178.764 185.676L179.396 186.45ZM173.875 190.959L173.243 190.184L172.875 190.484V190.959H173.875ZM174.354 196.3V197.3L174.357 197.3L174.354 196.3ZM177.71 196.291L177.713 197.291L177.715 197.291L177.71 196.291ZM178.187 195.816H177.187V195.816L178.187 195.816ZM181.062 195.814L182.062 195.817V195.814H181.062ZM181.541 196.291L181.543 195.291H181.541L181.541 196.291ZM184.895 196.3L184.892 197.3H184.895V196.3ZM185.374 190.955H186.374V190.481L186.007 190.181L185.374 190.955ZM179.854 186.45L180.487 185.675L180.479 185.669L179.854 186.45ZM188.117 189.515L187.485 190.289L187.49 190.293L188.117 189.515ZM185.614 187.468H184.614V187.943L184.981 188.243L185.614 187.468ZM183.218 185.512L182.586 186.287L184.218 187.618V185.512H183.218ZM180.537 183.325L179.905 184.1L179.905 184.1L180.537 183.325ZM179.624 183V184V183ZM178.711 183.325L178.078 182.55L178.078 182.55L178.711 183.325ZM171.13 189.515L170.498 188.74L170.497 188.741L171.13 189.515ZM171.082 190.016L171.852 189.378L171.85 189.376L171.082 190.016ZM171.846 190.937L172.616 190.298L172.616 190.298L171.846 190.937ZM172.352 190.985L171.72 190.211L171.719 190.212L172.352 190.985ZM179.396 185.233L178.772 184.451L178.764 184.458L179.396 185.233ZM179.854 185.233L180.487 184.458L180.479 184.452L179.854 185.233ZM186.899 190.985L187.533 190.212L187.531 190.211L186.899 190.985ZM187.405 190.938L188.173 191.578L188.174 191.576L187.405 190.938ZM188.168 190.017L188.938 190.656L188.938 190.655L188.168 190.017ZM178.764 185.676L173.243 190.184L174.508 191.733L180.029 187.225L178.764 185.676ZM172.875 190.959V195.825H174.875V190.959H172.875ZM172.875 195.825C172.875 196.219 173.033 196.595 173.311 196.871L174.72 195.451C174.818 195.549 174.875 195.683 174.875 195.825H172.875ZM173.311 196.871C173.59 197.147 173.965 197.3 174.354 197.3V195.3C174.49 195.3 174.621 195.353 174.72 195.451L173.311 196.871ZM174.357 197.3L177.713 197.291L177.707 195.291L174.352 195.3L174.357 197.3ZM177.715 197.291C178.103 197.289 178.477 197.135 178.753 196.86L177.341 195.443C177.439 195.346 177.57 195.292 177.705 195.291L177.715 197.291ZM178.753 196.86C179.03 196.584 179.187 196.209 179.187 195.816L177.187 195.816C177.187 195.675 177.243 195.541 177.341 195.443L178.753 196.86ZM179.187 195.816V192.975H177.187V195.816H179.187ZM179.187 192.975C179.187 193.117 179.13 193.251 179.031 193.349L177.623 191.928C177.345 192.204 177.187 192.581 177.187 192.975H179.187ZM179.031 193.349C178.933 193.446 178.801 193.499 178.666 193.499V191.499C178.276 191.499 177.901 191.653 177.623 191.928L179.031 193.349ZM178.666 193.499H180.582V191.499H178.666V193.499ZM180.582 193.499C180.447 193.499 180.315 193.446 180.217 193.349L181.625 191.928C181.347 191.653 180.972 191.499 180.582 191.499V193.499ZM180.217 193.349C180.119 193.251 180.062 193.117 180.062 192.975H182.062C182.062 192.581 181.904 192.204 181.625 191.928L180.217 193.349ZM180.062 192.975V195.814H182.062V192.975H180.062ZM180.062 195.811C180.061 196.006 180.099 196.2 180.174 196.38L182.021 195.613C182.048 195.678 182.062 195.747 182.062 195.817L180.062 195.811ZM180.174 196.38C180.249 196.56 180.358 196.723 180.496 196.86L181.907 195.442C181.955 195.491 181.994 195.549 182.021 195.613L180.174 196.38ZM180.496 196.86C180.634 196.997 180.797 197.105 180.976 197.179L181.738 195.33C181.8 195.356 181.858 195.394 181.907 195.442L180.496 196.86ZM180.976 197.179C181.156 197.253 181.347 197.291 181.541 197.291L181.541 195.291C181.608 195.291 181.675 195.304 181.738 195.33L180.976 197.179ZM181.538 197.291L184.892 197.3L184.898 195.3L181.543 195.291L181.538 197.291ZM184.895 197.3C185.285 197.3 185.66 197.147 185.938 196.871L184.53 195.451C184.628 195.353 184.76 195.3 184.895 195.3V197.3ZM185.938 196.871C186.216 196.595 186.374 196.219 186.374 195.825H184.374C184.374 195.683 184.431 195.549 184.53 195.451L185.938 196.871ZM186.374 195.825V190.955H184.374V195.825H186.374ZM186.007 190.181L180.487 185.675L179.222 187.225L184.742 191.73L186.007 190.181ZM180.479 185.669C180.236 185.475 179.935 185.37 179.625 185.37V187.37C179.483 187.37 179.343 187.322 179.23 187.231L180.479 185.669ZM179.625 185.37C179.316 185.37 179.015 185.475 178.772 185.669L180.021 187.231C179.908 187.322 179.768 187.37 179.625 187.37V185.37ZM188.75 188.74L186.247 186.694L184.981 188.243L187.485 190.289L188.75 188.74ZM186.614 187.468V184.306H184.614V187.468H186.614ZM186.614 184.306C186.614 183.943 186.469 183.598 186.213 183.344L184.805 184.764C184.683 184.644 184.614 184.479 184.614 184.306H186.614ZM186.213 183.344C185.957 183.09 185.612 182.95 185.255 182.95V184.95C185.087 184.95 184.925 184.884 184.805 184.764L186.213 183.344ZM185.255 182.95H183.578V184.95H185.255V182.95ZM183.578 182.95C183.22 182.95 182.875 183.09 182.619 183.344L184.028 184.764C183.907 184.884 183.745 184.95 183.578 184.95V182.95ZM182.619 183.344C182.364 183.598 182.218 183.943 182.218 184.306H184.218C184.218 184.479 184.149 184.644 184.028 184.764L182.619 183.344ZM182.218 184.306V185.512H184.218V184.306H182.218ZM183.85 184.737L181.169 182.55L179.905 184.1L182.586 186.287L183.85 184.737ZM181.169 182.55C180.733 182.194 180.187 182 179.624 182V184C179.728 184 179.827 184.036 179.905 184.1L181.169 182.55ZM179.624 182C179.061 182 178.515 182.194 178.078 182.55L179.343 184.1C179.421 184.036 179.52 184 179.624 184V182ZM178.078 182.55L170.498 188.74L171.763 190.289L179.343 184.099L178.078 182.55ZM170.497 188.741C170.359 188.854 170.244 188.993 170.16 189.151L171.924 190.094C171.884 190.169 171.829 190.235 171.764 190.288L170.497 188.741ZM170.16 189.151C170.076 189.309 170.023 189.482 170.006 189.661L171.997 189.851C171.989 189.936 171.964 190.019 171.924 190.094L170.16 189.151ZM170.006 189.661C169.989 189.839 170.008 190.019 170.061 190.19L171.971 189.598C171.996 189.679 172.005 189.765 171.997 189.851L170.006 189.661ZM170.061 190.19C170.114 190.361 170.2 190.52 170.315 190.657L171.85 189.376C171.904 189.441 171.946 189.516 171.971 189.598L170.061 190.19ZM170.313 190.655L171.076 191.575L172.616 190.298L171.852 189.378L170.313 190.655ZM171.076 191.575C171.191 191.713 171.33 191.826 171.488 191.909L172.422 190.141C172.496 190.18 172.562 190.233 172.616 190.298L171.076 191.575ZM171.488 191.909C171.645 191.992 171.817 192.044 171.994 192.061L172.184 190.07C172.267 190.078 172.348 190.102 172.422 190.141L171.488 191.909ZM171.994 192.061C172.171 192.077 172.349 192.06 172.519 192.008L171.938 190.094C172.018 190.07 172.102 190.062 172.184 190.07L171.994 192.061ZM172.519 192.008C172.689 191.956 172.848 191.872 172.986 191.759L171.719 190.212C171.784 190.158 171.859 190.118 171.938 190.094L172.519 192.008ZM172.985 191.76L180.029 186.007L178.764 184.458L171.72 190.211L172.985 191.76ZM180.021 186.014C179.908 186.104 179.768 186.153 179.625 186.153V184.153C179.316 184.153 179.015 184.257 178.772 184.452L180.021 186.014ZM179.625 186.153C179.483 186.153 179.343 186.104 179.23 186.014L180.479 184.452C180.236 184.257 179.935 184.153 179.625 184.153V186.153ZM179.222 186.007L186.266 191.76L187.531 190.211L180.487 184.458L179.222 186.007ZM186.264 191.758C186.402 191.871 186.56 191.956 186.73 192.008L187.314 190.095C187.393 190.119 187.468 190.159 187.533 190.212L186.264 191.758ZM186.73 192.008C186.9 192.06 187.078 192.078 187.255 192.061L187.068 190.07C187.151 190.062 187.234 190.07 187.314 190.095L186.73 192.008ZM187.255 192.061C187.432 192.044 187.604 191.993 187.761 191.911L186.831 190.14C186.905 190.101 186.985 190.078 187.068 190.07L187.255 192.061ZM187.761 191.911C187.918 191.828 188.058 191.715 188.173 191.578L186.637 190.297C186.691 190.232 186.757 190.179 186.831 190.14L187.761 191.911ZM188.174 191.576L188.938 190.656L187.399 189.379L186.635 190.299L188.174 191.576ZM188.938 190.655C189.052 190.518 189.139 190.358 189.191 190.186L187.278 189.602C187.303 189.52 187.344 189.444 187.398 189.379L188.938 190.655ZM189.191 190.186C189.243 190.014 189.261 189.834 189.243 189.655L187.253 189.856C187.245 189.771 187.253 189.684 187.278 189.602L189.191 190.186ZM189.243 189.655C189.225 189.476 189.171 189.302 189.086 189.145L187.328 190.099C187.288 190.024 187.262 189.942 187.253 189.856L189.243 189.655ZM189.086 189.145C189 188.987 188.884 188.848 188.745 188.736L187.49 190.293C187.424 190.24 187.369 190.174 187.328 190.099L189.086 189.145Z"
      fill="#888579"
      mask="url(#path-109-outside-1_13_14293)"
    />
    <defs>
      <linearGradient id="paint0_linear_13_14293" x1={323} y1={352} x2={17.1175} y2={352.001} gradientUnits="userSpaceOnUse">
        <stop stopOpacity={0} />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient id="paint1_linear_13_14293" x1={341} y1={370} x2={35.1175} y2={370.001} gradientUnits="userSpaceOnUse">
        <stop stopOpacity={0} />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient id="paint2_linear_13_14293" x1={682} y1={352} x2={376.117} y2={352.001} gradientUnits="userSpaceOnUse">
        <stop stopOpacity={0} />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient id="paint3_linear_13_14293" x1={341} y1={11} x2={35.1175} y2={11.0012} gradientUnits="userSpaceOnUse">
        <stop stopOpacity={0} />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient id="paint4_linear_13_14293" x1={341} y1={366} x2={35.1175} y2={366.001} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DDD8C8" />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopColor="#DDD8C8" />
      </linearGradient>
      <linearGradient id="paint5_linear_13_14293" x1={327} y1={352} x2={21.1175} y2={352.001} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DDD8C8" />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopColor="#DDD8C8" />
      </linearGradient>
      <linearGradient id="paint6_linear_13_14293" x1={678} y1={352} x2={372.117} y2={352.001} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DDD8C8" />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopColor="#DDD8C8" />
      </linearGradient>
      <linearGradient id="paint7_linear_13_14293" x1={341} y1={15} x2={35.1175} y2={15.0012} gradientUnits="userSpaceOnUse">
        <stop stopColor="#DDD8C8" />
        <stop offset={0.525547} stopColor="white" />
        <stop offset={1} stopColor="#DDD8C8" />
      </linearGradient>
    </defs>
  </svg>
)

export default BoardNx
